export default __webpack_public_path__ + "static/B0019-c3760c03d3b1fc0a1e9603e86c24cd1b.png";